"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.executeFunction = executeFunction;
exports.prepareTransactionBlock = prepareTransactionBlock;
exports.prepareArgs = prepareArgs;
const transactions_1 = require("@mysten/sui/transactions");
async function executeFunction(context, functionName, args, txb) {
    if (!context.currentAccount) {
        throw new Error("No account connected!");
    }
    console.log("Function:", functionName);
    console.log("Type Args: ", args.typeArgs);
    console.log("Args:", args.args, txb);
    // Execute the Move call with the formatted arguments
    // txb.moveCall({
    //   target: functionName,
    //   typeArguments: args.typeArgs,
    //   arguments: args.args,
    // });
    // context.suiClient.signAndExecuteTransactionBlock({
    //   transactionBlock: txb,
    //   signer:  context.currentAccount.
    // });
    console.log("Move call executed.");
}
function prepareTransactionBlock() {
    const txb = new transactions_1.Transaction();
    return txb;
}
function prepareArgs(params, txb) {
    // Prepare arguments based on their type
    const typeArgs = [];
    const args = [];
    params.map((param) => {
        switch (param.type) {
            case "type":
                typeArgs.push(param.value);
                return null;
            case "object":
                // For object type, use txb.object to create a reference to the object
                args.push(txb.object(param.value));
                return null;
            case "txObject":
                args.push(param.value);
                return null;
            case "u8":
            case "u16":
            case "u32":
            case "u64":
            case "u128":
            case "u256":
            case "bool":
            case "address":
                // For primitive types like u8, directly use the value
                // Make sure to convert the value to the correct type (e.g., number for u8)
                args.push(txb.pure(param.value));
                return null;
            default:
                // Handle other types as needed or throw an error for unsupported types
                throw new Error(`Unsupported argument type: ${param.type}`);
        }
    });
    return { typeArgs, args };
}
//# sourceMappingURL=callSmartContractFunction.js.map